import { Injectable } from '@angular/core';
import {
  HttpRequest, 
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';

import { AuthenticationService } from '../services/authentication.service';
import { Observable } from 'rxjs';

@Injectable()
export class JwtInterceptor implements HttpInterceptor {

  constructor(private authenticationService: AuthenticationService) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    let currentUser = this.authenticationService.currentUserValue;

    if (currentUser && currentUser.accessToken) {
      request = request.clone({
        setHeaders: { 'Authorization': `Bearer ${ currentUser.accessToken }` }
      });
    }

    return next.handle(request);
  }
}
